<template>
  <footer class="the-footer mt-200 mb-400">
    <section class="banner content-wrap px-100 mb-300">
      <div class="flex flex-wrap gap-200 mb-200">
        <TheFooterRegisteredCourier
          v-if="variant === 'full'"
          class="banner-child the-footer-registered-courier py-200 px-300"
        />

        <LcCard radius="large" shadow="none" class="payment-icons">
          <PaymentMethodSymbols key="payment-icons" gap="lg" outlined />
        </LcCard>

        <TheFooterLinkCollection
          v-if="!isNativeApp"
          class="banner-child py-300 px-400"
          gap="md"
          type="app"
        />
      </div>
      <div class="flex flex-wrap gap-200">
        <TheFooterLinkCollection
          class="banner-child py-300 px-400"
          full-width
          gap="2xl"
          type="social"
        />
        <article class="banner-child py-100 px-200">
          <LanguageSwitch variant="discreet" />
        </article>
      </div>
    </section>

    <section class="foot-note">
      <div class="content-wrap flex flex-col gap-300 px-200">
        <TheFooterNavigation />

        <article v-if="content" class="address caption-regular flex flex-wrap">
          <strong v-if="content.copyright">
            {{ content.copyright }}
          </strong>
          <p v-if="content.address">
            {{ content.address }}
          </p>
        </article>

        <TheFooterResponsiblePlay />
      </div>
    </section>
  </footer>
</template>

<script lang="ts" setup>
import type { TheFooterProps } from '~/components/TheFooter/TheFooter.vue'

const { variant = 'condensed' } = defineProps<TheFooterProps>()

const { data: footer } = useContent().getFooter()
const { isNativeApp } = useCustomContext()

const content = computed(() => {
  if (!footer.value?.items?.[0]) return null
  const { addressLine, copyrightLine } = footer.value.items[0]

  return {
    address: addressLine ?? null,
    copyright: copyrightLine ?? null,
  }
})
</script>

<style lang="scss" scoped>
$banner-child-width: 368px;

.the-footer {
  .payment-icons {
    width: 100%;
    padding: token('size/space/gap/100') token('size/space/gap/200');
  }

  .banner
    > div:has(.the-footer-registered-courier):not(
      :has(.the-footer-registered-courier ~ .the-footer-registered-courier)
    )
    .payment-icons {
    flex-grow: 1;
    width: $banner-child-width;
  }

  .address {
    column-gap: token('size/space/gap/200');
  }

  .banner :deep(.banner-child) {
    flex-grow: 1;
    width: $banner-child-width;
    border-radius: token('size/radius/l');
    background-color: token('color/background/primary/primary');
  }

  .foot-note {
    color: token('color/text/primary/primary');
  }
}
</style>
